import React, { useMemo, useRef } from 'react';
import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';

function DebounceSelect({
  data,
  onLookup,
  debounceTimeout = 800,
  fetching,
  ...props
}) {
  // const [fetching, setFetching] = useState(false);
  // const [options, setOptions] = useState([]);
  // const fetchRef = useRef(0);

  const debounceFetcher = useMemo(() => {
    // const loadOptions = (value) => {
    //   fetchRef.current += 1;
    //   const fetchId = fetchRef.current;
    //   setOptions([]);
    //   setFetching(true);
    //   fetchOptions(value).then((newOptions) => {
    //     if (fetchId !== fetchRef.current) {
    //       // for fetch callback order
    //       return;
    //     }

    //     setOptions(newOptions);
    //     setFetching(false);
    //   });
    // };

    return debounce(onLookup, debounceTimeout);
  }, [onLookup, debounceTimeout]);

  console.log("fetching ///", fetching)
  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={data ? data : []}
    />
  );
}

export default DebounceSelect;
